/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useApp } from "../contexts/AppContext";
import { toast } from "sonner";
import { Globe, Loader2, Check } from "lucide-react";

const FALLBACK = [
  { code: "CD", nom: "RD Congo", drapeau: "🇨🇩", devise: "USD", regime_nom: "Forfait Bombacare · Mobile Money" },
  { code: "FR", nom: "France", drapeau: "🇫🇷", devise: "EUR", regime_nom: "NGAP · télésoin TMK" },
  { code: "BE", nom: "Belgique", drapeau: "🇧🇪", devise: "EUR", regime_nom: "INAMI" },
  { code: "NL", nom: "Pays-Bas", drapeau: "🇳🇱", devise: "EUR", regime_nom: "Tarifs libres par assureur" },
  { code: "GB", nom: "Royaume-Uni", drapeau: "🇬🇧", devise: "GBP", regime_nom: "Private practice" },
];

export function usePaysList() {
  const [list, setList] = useState(() => { try { return JSON.parse(localStorage.getItem("bc_pays_list")) || FALLBACK; } catch { return FALLBACK; } });
  useEffect(() => { api.get("/profile/pays").then(({ data }) => { setList(data); localStorage.setItem("bc_pays_list", JSON.stringify(data)); }).catch(() => null); }, []);
  return list;
}

/** Grille de choix du pays (inscription, profil, réglages). `value` = code ISO ; `onChange(code)`. */
export function CountryGrid({ value, onChange, pro, testPrefix = "pays" }) {
  const list = usePaysList();
  return (
    <div data-testid={`${testPrefix}-grid`} className="grid grid-cols-2 sm:grid-cols-3 gap-2">
      {list.map((p) => (
        <button type="button" key={p.code} data-testid={`${testPrefix}-${p.code}`} onClick={() => onChange(p.code)}
          className={`text-left rounded-2xl border p-3 transition-colors ${value === p.code ? "border-[#2BA3A0] bg-[#2BA3A0]/10" : "border-[#E4E0D5] bg-white hover:bg-[#F5F3EE]"}`}>
          <div className="flex items-center justify-between"><span className="text-xl">{p.drapeau}</span>{value === p.code && <Check size={16} className="text-[#2BA3A0]" />}</div>
          <div className="font-bold text-[13px] text-[#0A1426] mt-1">{p.nom}</div>
          <div className="text-[11px] text-[#0A1426]/60">{p.devise}{pro ? ` · ${p.regime_nom}` : ""}</div>
        </button>
      ))}
    </div>
  );
}

/** Écran plein (première utilisation) : « Où exercez-vous / où vivez-vous ? » */
export function CountryOnboarding() {
  const { profile, setPays } = useApp();
  const [sel, setSel] = useState(profile?.pays || "");
  const [busy, setBusy] = useState(false);
  if (!profile?.a_choisir) return null;
  const pro = profile.role === "therapeute";
  const save = async () => {
    setBusy(true);
    try { await setPays(sel); toast.success("Profil enregistré"); } catch { toast.error("Enregistrement impossible"); }
    setBusy(false);
  };
  return (
    <div data-testid="country-onboarding" className="fixed inset-0 z-[96] bg-[#0A1426]/70 backdrop-blur-sm grid place-items-center p-4">
      <div className="bg-white rounded-3xl w-full max-w-lg p-6 flex flex-col gap-4">
        <div className="flex items-center gap-2 text-[#0A1426]"><Globe size={20} className="text-[#2BA3A0]" /><h2 className="font-[Fraunces] text-xl font-bold">{pro ? "Où exercez-vous ?" : "Où vivez-vous ?"}</h2></div>
        <p className="text-[13px] text-[#0A1426]/70">Une seule application : votre pays active les bonnes fonctionnalités (langues, devise, numéros d'urgence, paiement{pro ? ", nomenclature et règles de facturation des séances vidéo" : ""}). Modifiable ensuite dans {pro ? "Télésoin › Réglages" : "Profil"}.</p>
        <CountryGrid value={sel} onChange={setSel} pro={pro} testPrefix="onb-pays" />
        <button data-testid="country-onboarding-save" disabled={!sel || busy} onClick={save} className="h-12 rounded-full bg-[#2BA3A0] text-white font-bold disabled:opacity-50 grid place-items-center">
          {busy ? <Loader2 className="animate-spin" size={16} /> : "Continuer"}
        </button>
      </div>
    </div>
  );
}
